import ValidService from "@/service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
  title: null, // required, minLength: 1 - Tiêu đề bài viết
  content: '', // required, minLength: 1 - [Markdown] Nội dung bài viết
  image: null, // required, ref: mushroom_file - Mã ảnh
  publish: null,
  status: null, // required, enum(WAITING_APPROVER, REQUEST_EDIT, APPROVERED) - Trạng thái
  category_id: null, // required, ref: category_news - Mã danh mục tin tức
  notes: [],
  creator_id: null, // required - Mã người tạo
  is_important: null, // required - Có phải là danh mục nổi bật không?
};

// validation form
model.validForm = {
  name: [ValidService.required], // required - Tên danh mục tin
  order: [ValidService.checkNumberInteger, ValidService.checkNumberFloatNotNegative], // optional - Thứ tự
  is_important: [ValidService.requiredChange], // required - Có phải là danh mục nổi bật không?
  title: [ValidService.required, ValidService.checkSpaceString], // required, minLength: 1 - Tiêu đề bài viết
  content: [ValidService.required, ValidService.checkSpaceString], // required, minLength: 1 - [Markdown] Nội dung bài viết
  image: [ValidService.requiredChange], // required, ref: mushroom_file - Mã ảnh
  status: [ValidService.requiredChange], // required, enum(WAITING_APPROVER, REQUEST_EDIT, APPROVERED) - Trạng thái
  category_id: [ValidService.requiredChange], // required, ref: category_news - Mã danh mục tin tức
  creator_id: [ValidService.requiredChange], // required - Mã người tạo
};

model.listNewsStatus = [
  {
    label: 'Chờ duyệt',
    value: 'WAITING_APPROVER'
  },
  {
    label: 'Yêu cầu chỉnh sửa',
    value: 'REQUEST_EDIT'
  },
  {
    label: 'Đã duyệt',
    value: 'APPROVERED'
  },
]

model.listOutStanding = [
  {
    label: 'Có',
    value: true
  },
  {
    label: 'Không',
    value: false
  },
]

model.tableRules = {
  data: [],
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: true,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 10,
  offset: 0,
  sort: "-created_at",
  defaultSort: ["created_at", "descending"],
  filters: "",
  recordSelected: [],
  dataSearch: {
    value: {
      title: null,
      category_id: null,
      content: null,
      creator_id: null,
      status: null,
      disabled: null,
      is_important: null,
    },
    valid: {
    },
    operator: {
      title: '$vn_text=',
      category_id: '',
      content: ':regex_i:',
      creator_id: '',
      status: '',
      disabled: '',
      is_important: ''
    }
  }
};

model.matchStatusName = (status) => {
  return status == "WAITING_APPROVER"
          ? "Chờ duyệt"
          : status == "REQUEST_EDIT"
            ? "Yêu cầu chỉnh sửa"
            : status == "APPROVERED"
              ? "Đã duyệt"
              : ""
}

export default model;
